import React from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { WifiOff, AlertTriangle } from 'lucide-react';

export const NetworkStatusBanner: React.FC = () => {
  const { state, message } = useNetworkStatus();

  if (state === 'online' || !message) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[100] px-4 py-2.5 text-center text-xs font-medium tracking-wide flex items-center justify-center gap-2 ${
        state === 'offline'
          ? 'bg-destructive text-destructive-foreground'
          : 'bg-[hsl(45,83%,53%)] text-[#1a1a1a]'
      }`}
    >
      {state === 'offline' ? (
        <WifiOff className="h-3.5 w-3.5 flex-shrink-0" />
      ) : (
        <AlertTriangle className="h-3.5 w-3.5 flex-shrink-0" />
      )}
      <span>{message}</span>
    </div>
  );
};
